export const UNLOCK_INVENTORY_FORM_INITIAL_VALUES = {
  fullName: '',
  email: '',
  phoneNumber: 0,
  dealershipName: '',
  dealershipState: null,
  inventorySyndicationProvider: null,
  creditApplicationSystem: [],
  confirmPrice: false,
  confirmTerms: false,
};

export const PHONE_FORMAT = '+1 (###)-###-####';

export const INVENTORY_SYNDICATION_PROVIDERS = [
  'Other',
  '1800MYAUTO.COM',
  '360VinSpin',
  'ACS Automotive',
  'ADAM',
  'Adamdms',
  'ADIMS / Intellventory',
  'Advancedautodealers',
  'Advent',
  'Affordable Computer Systems',
  'AIM Experts',
  'All Auto Network',
  'Applied Computer Solutions',
  'ASN Software Technologies',
  'Auction 123',
  'Authenticom',
  'Auto Action',
  'Auto Ad Manager',
  'Auto Corner',
  'Auto Dealers.Digital',
  'Auto Exact',
  'Auto Fusion/Motion Pix',
  'Auto Master / ASM',
  'Auto Nexus',
  'Auto Revo/AXX',
  'Auto Revolution',
  'Auto Xplorer',
  'AutoAdManager',
  'Autobase',
  'AutoClick',
  'AutoConX',
  'AutoDealerPro',
  'AutoDealerSystems',
  'Autodealertech',
  'AutoDeals',
  'AutoDrivenMarketing',
  'Autoexperts',
  'AutoExplorer',
  'AutoFlexLog Inc.',
  'AutoFunds',
  'Autofusion',
  'Autolahome',
  'Autolot Manager',
  'AutoManager',
  'AutoMate',
  'AutoMatrix',
  'AutoNation',
  'Autonet Dealer Solutions/ASL',
  'Autopoint',
  'AutoSearchTech',
  'Autosoft',
  'AutoStar Solutions',
  'AutoSweet',
  'AutoUpLink',
  'AutoVision',
  'Autoxloo.com',
  'Bargain News',
  'Big Voice',
  'BitBeater',
  'Boost Motor Group (Boost Media)',
  'Booth Creek IT',
  'BU Aux Feed',
  'Buybuymotors',
  'Camping World',
  'Car Spot Base',
  'Carbase',
  'CarCutter',
  'CarFluent',
  'Cargigi',
  'Cargurus',
  'CaRite',
  'Carlot Manager',
  'CarPages',
  'Carprolive',
  'CarsForSale.com',
  'CarThink',
  'CarWare',
  'CarWeek',
  'CarWhizzer',
  'CarWizard',
  'cDemo',
  'CDK Global',
  'Chroma Cars',
  'Contact Dealer - This will Delay Your Setup',
  'CT Wizard',
  'D2C Media',
  'Data One Software',
  'DCLTeam',
  'DCS Software',
  'Dealer 123',
  'Dealer Active',
  'Dealer Car Search',
  'Dealer Click',
  'Dealer Data',
  'Dealer eProcess',
  'Dealer FTP',
  'Dealer Fusion',
  'Dealer Inspire',
  'Dealer Made',
  'Dealer Motive',
  'Dealer Peak',
  'Dealer Solutions',
  'Dealer Specialties',
  'Dealer Trend',
  'Dealer Upload',
  'Dealer Vision (formerly Auto Express)',
  'Dealer Websites',
  'Dealer-Soft',
  'Dealer.com',
  'DealerBuilt / Lighyear',
  'DealerCenter',
  'DealerCorp / Deskit',
  'Dealercue (VinCue)',
  'DealerDNA',
  'DealerEbiz',
  'DealerFire',
  'DealerFront',
  'DealerImagePro',
  'DealerMate',
  'Dealeron',
  'Dealerpull',
  'DealersCloud',
  'DealersGear',
  'Dealership IDS',
  'Dealershipt Systems',
  'Dealerskins',
  'Dealerslink',
  'DealerSocket',
  'Dealersource',
  'DealerSpecialties',
  'DealerSpike',
  'DealerSync',
  'DealerTeam',
  'DealerTrack',
  'DealerVault',
  'DealerZone',
  'Dealr.Cloud',
  'DealTimer',
  'Devventure / Auto Sweet of Texas',
  'DPC Systems',
  'DriveGroup',
  'DVIM',
  'DX1',
  'eBizAutos',
  'EDealer.ca',
  'EDS',
  'Eleads',
  'Everlogic',
  'Evollo/Dealercity',
  'EZ Results',
  'EZ360',
  'EZDealer',
  'FCA Database',
  'FEX DMS',
  'Finance Express',
  'First Look',
  'FISKER',
  'Ford VinReal',
  'Fox Dealer',
  'Frazer',
  'Friday Systems',
  'FZAutomotive',
  'General Motors',
  'Genesys System',
  'Get My Auto',
  'Glo3dnet',
  'Goxee Dealer',
  'GreenBayWebDesign',
  'HellorampAI',
  'Higher Turnover',
  'Homenet',
  'Idealer',
  'ImageUploadFix',
  'IMagicLabs',
  'InfinitiNet',
  'Inloher Corp',
  'Innovative Dealer Solutions - IDS',
  'Integrated Dealer Systems - IDS',
  'InteractRV',
  'Inventory Command Center (ICC)',
  'Inventory Marketing/Vehicle Promote',
  'Inventory+',
  'IOCOM',
  'JD Byrider API',
  'JTZ Enterprise',
  'Kelley Karpower',
  'KGISolutions',
  'KST Data',
  'Lakeside Auto Mart',
  'Larry H Miller Data',
  'Lautopak',
  'LESA',
  'Level 5',
  'Level12',
  'Lexus API',
  'Lightspeed',
  'Lincoln API',
  'Lincoln Elite',
  'Link to the Future',
  'Liquid Motors',
  'Lithia',
  'Lookatusedcars',
  'Lot Boys',
  'Mach20Autos',
  'Manual Entry',
  'MaxDigital',
  'Micro 21',
  'Microsoft VPN',
  'MotorCar',
  'Motorcar Marketing',
  'Motorlot',
  'Motortrack',
  'MPK',
  'N/A',
  'Nabthat',
  'Netlook',
  'Nexteppe',
  'Nextgear',
  'NextStep',
  'None',
  'Oasis Auto Complete Systems',
  'OKLIX',
  'One Eighty Corp',
  'Order Automation',
  'Overfuel',
  'PBS',
  'PRCO',
  'PRcoPower',
  'Pro Response to HN Server',
  'Procede Software',
  'ProMax',
  'Proquotes / Quorum',
  'Quantech',
  'Quorum',
  'Radiant Concepts',
  'Redbumper / CDK Connected Lot',
  'RedlineAdvantage',
  "Reynolds RCO (won't include photos/comments)",
  'Reynolds Webs Solutions (Naked Lime)',
  'Ridemotive',
  'RyanTech',
  'SacAutos',
  'SalesForce',
  'Scorekeyper',
  'Search Optics',
  'SelectQu',
  'Serti',
  'ShiftPoint',
  'Sincro / Cobalt Website',
  'Sincro Digital',
  'Skywerks',
  'Smar Web Concepts',
  'Solutions Media 360 (SM360)',
  'Sonic / DDC',
  'Speed Digital',
  'SpinCar',
  'Spyne',
  'Strathcom',
  'String Automotive/Captive Lead',
  'SupremeSoftware',
  'SureFire',
  'Systems 2000',
  'Talon/Room58',
  'Teklon',
  'Tesla Batch',
  'Teton Solutions',
  'Toyota Shift (SDIS)',
  'Trader.ca',
  'Trans World Data',
  'Traver Technologies',
  'Tred',
  'TurboDeal',
  'Uautobee',
  'Unity Media Works',
  'USC Datacaster',
  'USC Feed',
  'V12 Software',
  'Valsoft',
  'VAST Data',
  'vAuto',
  'Vehicle Command - DMI',
  'Vehicle Details',
  'Vehicle Network',
  'Vin Solutions',
  'VIN Tracker',
  'VinList',
  'VINsource',
  'VinStickers/ESP Data',
  'Vision Design',
  'Vroom',
  'Walk The Lot',
  'Wayne Reaves',
  'Webentory',
  'WholeMax',
  'Wilson Software',
  'Wincarsdms',
  'XI Group',
  'Your Car Lot - GW Marketing',
  'ZeusConcepts',
  'ZopMedia',
];
